import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { LogStore } from './+state/log.store';
import { LogService } from './service/log.service';

export function provideLog(): EnvironmentProviders {
  return makeEnvironmentProviders([LogService, LogStore]);
}
